import { render } from "./NFPage.vue?vue&type=template&id=a1a8b79a"
import script from "./NFPage.vue?vue&type=script&lang=js"
export * from "./NFPage.vue?vue&type=script&lang=js"
script.render = render

export default script